export const kn = {
  nav: {
    home: "ಮುಖಪುಟ",
    about: "ನಮ್ಮ ಬಗ್ಗೆ",
    services: "ಸೇವೆಗಳು",
    doctors: "ವೈದ್ಯರು",
    branches: "ಶಾಖೆಗಳು",
    gallery: "ಗ್ಯಾಲರಿ",
    contact: "ಸಂಪರ್ಕ",
    bookAppointment: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ",
    call: "ಕರೆ ಮಾಡಿ",
    whatsapp: "ವಾಟ್ಸಾಪ್",
    book: "ಬುಕ್ ಮಾಡಿ"
  },
  hero: {
    society: "ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ ಮತ್ತು ಸೈಟ್ ಕೇರ್ ಸೊಸೈಟಿ",
    titleLine1: "ಸ್ಪಷ್ಟ ದೃಷ್ಟಿ.",
    titleLine2: "ಉತ್ತಮ ಆರೈಕೆ.",
    description: "ನಿಮ್ಮ ಕಣ್ಣಿನ ಆರೋಗ್ಯಕ್ಕೆ ಮೀಸಲಾದ ಅತ್ಯಾಧುನಿಕ ಹಾಗೂ ವಿಶ್ವಾಸಾರ್ಹ ನೇತ್ರ ಚಿಕಿತ್ಸೆ. ೬ ಆಧುನಿಕ ಕೇಂದ್ರಗಳಲ್ಲಿ ನುರಿತ ತಜ್ಞರಿಂದ ಶ್ರೇಷ್ಠ ಚಿಕಿತ್ಸೆ ಪಡೆಯಿರಿ.",
    bookAppointment: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಕಾಯ್ದಿರಿಸಿ",
    callNow: "ಈಗಲೇ ಕರೆ ಮಾಡಿ",
    whatsapp: "ವಾಟ್ಸಾಪ್",
    tagline: "ಮಾನವೀಯ ಸ್ಪರ್ಶದೊಂದಿಗೆ ಕಣ್ಣಿನ ಆರೈಕೆ",
    counter: "೦೧ / ೦೩"
  },
  features: {
    f1Title: "ಕಣ್ಣಿನ ಆರೋಗ್ಯಕ್ಕೆ ಆದ್ಯತೆ",
    f1Desc: "ನಿಮ್ಮ ದೃಷ್ಟಿಯ ಸಂಪೂರ್ಣ ಕಾಳಜಿ",
    f2Title: "ರೋಗಿಗಳಿಗೆ ಮೊದಲ ಪ್ರಾಶಸ್ತ್ಯ",
    f2Desc: "ಪ್ರತಿ ಹಂತದಲ್ಲೂ ಸೂಕ್ತ ಚಿಕಿತ್ಸೆ",
    f3Title: "೬ ಸುಸಜ್ಜಿತ ಶಾಖಾ ಕೇಂದ್ರಗಳು",
    f3Desc: "ನಿಮ್ಮ ಸಮೀಪದಲ್ಲೇ ಅತ್ಯುತ್ತಮ ನೇತ್ರ ಸೇವೆ",
    f4Title: "ಎಲ್ಲಾ ವಯೋಮಾನದವರಿಗೂ ಆರೈಕೆ",
    f4Desc: "ಮಕ್ಕಳಿಂದ ಹಿರಿಯರವರೆಗೆ ಎಲ್ಲರಿಗೂ ಚಿಕಿತ್ಸೆ"
  },
  trust: {
    happyPatients: "ತೃಪ್ತ ರೋಗಿಗಳು",
    expertDoctors: "ತಜ್ಞ ವೈದ್ಯರು",
    yearsExperience: "ವರ್ಷಗಳ ಅನುಭವ",
    advancedBranches: "ಸುಸಜ್ಜಿತ ಶಾಖೆಗಳು"
  },
  servicesSection: {
    badge: "ನಮ್ಮ ಸೇವೆಗಳು",
    title: "ಪ್ರತಿಯೊಬ್ಬರ ದೃಷ್ಟಿಗೂ ಪರಿಪೂರ್ಣ ಆರೈಕೆ.",
    subtitle: "ಅತ್ಯಾಧುನಿಕ ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ನುರಿತ ನೇತ್ರ ತಜ್ಞರೊಂದಿಗೆ ನಿಮ್ಮ ದೃಷ್ಟಿಯನ್ನು ರಕ್ಷಿಸಲು ನಾವು ಸದಾ ಸಿದ್ಧ. ನಾವು ೧೬ಕ್ಕೂ ಹೆಚ್ಚು ವಿಶೇಷ ಚಿಕಿತ್ಸೆಗಳನ್ನು ನೀಡುತ್ತೇವೆ.",
    viewAll: "ಎಲ್ಲಾ ಸೇವೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    learnMore: "ಹೆಚ್ಚಿನ ವಿವರ",
    bookNow: "ಈಗಲೇ ಬುಕ್ ಮಾಡಿ",
    bookConsultation: "ಸಮಾಲೋಚನೆ ಕಾಯ್ದಿರಿಸಿ",
    enquire: "ವಿಚಾರಿಸಿ",
    pageBadge: "ವಿಶೇಷ ಚಿಕಿತ್ಸೆಗಳು • ೧೬ ಅತ್ಯಾಧುನಿಕ ನೇತ್ರ ಸೇವೆಗಳು",
    pageTitle: "ನಮ್ಮ ಸೇವೆಗಳು",
    pageSubtitle: "ಅತ್ಯಾಧುನಿಕ ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ಪರಿಣಿತ ನೇತ್ರ ಶಸ್ತ್ರಚಿಕಿತ್ಸಕರ ಮೂಲಕ ಸಮಗ್ರ ಕಣ್ಣಿನ ಚಿಕಿತ್ಸೆಗಳು. ನಿಮ್ಮ ದೃಷ್ಟಿ ಸುರಕ್ಷಿತ ಕೈಗಳಲ್ಲಿದೆ."
  },
  doctorsSection: {
    badge: "ನಮ್ಮ ತಜ್ಞರು",
    title: "ನಿಮ್ಮ ವೈದ್ಯರನ್ನು ಭೇಟಿಯಾಗಿ.",
    subtitle: "ನಿಮ್ಮ ದೃಷ್ಟಿ ರಕ್ಷಣೆಗೆ ಸದಾ ಶ್ರಮಿಸುವ ನುರಿತ ವೃತ್ತಿಪರರು.",
    meetDoctors: "ನಮ್ಮ ವೈದ್ಯರನ್ನು ಭೇಟಿಯಾಗಿ",
    specialistTag: "ನೇತ್ರ ಆರೈಕೆ ತಜ್ಞರು",
    portraitPlaceholder: "ಭಾವಚಿತ್ರ ಶೀಘ್ರದಲ್ಲೇ ಅಪ್‌ಡೇಟ್ ಆಗಲಿದೆ",
    bookConsultation: "ಸಮಾಲೋಚನೆ ಕಾಯ್ದಿರಿಸಿ",
    pageTitle: "ನಮ್ಮ ತಜ್ಞ ವೈದ್ಯರು",
    pageSubtitle: "ಅನುಭವಿ ನೇತ್ರಶಾಸ್ತ್ರಜ್ಞರು ಮತ್ತು ಕಣ್ಣಿನ ಶಸ್ತ್ರಚಿಕಿತ್ಸಕರ ತಂಡವನ್ನು ಭೇಟಿ ಮಾಡಿ. ನಿಮಗೆ ಉನ್ನತ ಗುಣಮಟ್ಟದ ವೈಯಕ್ತಿಕ ಕಣ್ಣಿನ ಆರೈಕೆ ನೀಡಲು ನಾವು ಬದ್ಧರಾಗಿದ್ದೇವೆ."
  },
  branchesSection: {
    badge: "ನಮ್ಮ ಜಾಲ",
    locationsCount: "೬ ಶಾಖೆಗಳು",
    title: "ನೇತ್ರ ಆರೈಕೆ, ನಿಮ್ಮದೇ ಊರಿನಲ್ಲಿ.",
    subtitle: "ಮಹಾರಾಷ್ಟ್ರ ಮತ್ತು ಕರ್ನಾಟಕದಾದ್ಯಂತ ಅತ್ಯಾಧುನಿಕ ತಪಾಸಣೆ ಮತ್ತು ಶಸ್ತ್ರಚಿಕಿತ್ಸಾ ಸೌಲಭ್ಯಗಳೊಂದಿಗೆ ನಿಮ್ಮ ಹತ್ತಿರದ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆಯನ್ನು ಕಂಡುಕೊಳ್ಳಿ.",
    viewAll: "ಎಲ್ಲಾ ಶಾಖೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    openToday: "ಇಂದು ತೆರೆದಿದೆ",
    filterDistrict: "ಕೇಂದ್ರ ಆಯ್ಕೆಮಾಡಿ:",
    allCenters: "ಎಲ್ಲಾ ಕೇಂದ್ರಗಳು",
    allCentersOpen: "ಎಲ್ಲಾ ೬ ಕೇಂದ್ರಗಳು ಇಂದು ತೆರೆದಿವೆ",
    dailyOpd: "ದೈನಂದಿನ ಒಪಿಡಿ: ಬೆಳಗ್ಗೆ ೯ - ರಾತ್ರಿ ೮",
    branchPrefix: "ಶಾಖೆ",
    of: "ರಲ್ಲಿ",
    tekkeCenter: "ಟೆಕ್ಕೆ ಸೆಂಟರ್",
    viewDetails: "ವಿವರಗಳನ್ನು ನೋಡಿ",
    call: "ಕರೆ",
    map: "ನಕ್ಷೆ",
    details: "ವಿವರ",
    contactNo: "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
    pageHeroBadge: "ಶಾಖೆಗಳು",
    pageHeroTitle: "ನಮ್ಮ ಸೇವಾ ಜಾಲ.",
    pageHeroSubtitle: "ಮಹಾರಾಷ್ಟ್ರ ಮತ್ತು ಕರ್ನಾಟಕದಾದ್ಯಂತ ೬ ಅತ್ಯಾಧುನಿಕ ಸೌಲಭ್ಯಗಳೊಂದಿಗೆ, ವಿಶ್ವದರ್ಜೆಯ ಕಣ್ಣಿನ ಆರೈಕೆ ಈಗ ನಿಮ್ಮ ಹತ್ತಿರದಲ್ಲಿದೆ.",
    statClinics: "೬ ಕ್ಲಿನಿಕ್‌ಗಳು",
    statClinicsDesc: "ಆಷ್ಟಾ, ಜತ್, ಆಟ್ಪಾಡಿ, ಸೋಲಾಪುರ, ಅಥಣಿ ಮತ್ತು ಸಾಂಗೋಲಾ",
    statBooking: "೨೪/೭ ಬುಕಿಂಗ್",
    statBookingDesc: "ಆನ್‌ಲೈನ್ ಮತ್ತು ವಾಟ್ಸಾಪ್ ಮೂಲಕ",
    findOnMap: "ನಕ್ಷೆಯಲ್ಲಿ ನಮ್ಮನ್ನು ಹುಡುಕಿ",
    navigate: "ದಾರಿದೀಪ",
    branchInfo: "ಶಾಖೆಯ ಮಾಹಿತಿ",
    address: "ವಿಳಾಸ",
    timings: "ಸಮಯ",
    availableFacilities: "ಲಭ್ಯವಿರುವ ಸೌಲಭ್ಯಗಳು",
    callBranch: "ಕರೆ ಮಾಡಿ",
    whatsappMessage: "ವಾಟ್ಸಾಪ್ ಸಂದೇಶ",
    doctorsAtBranch: "ಈ ಶಾಖೆಯ ತಜ್ಞ ವೈದ್ಯರು",
    bookAtBranch: "ಈ ಶಾಖೆಯಲ್ಲಿ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ",
    exploreAllMob: "ಎಲ್ಲಾ ೬ ಶಾಖೆಗಳು ಮತ್ತು ನಕ್ಷೆಗಳನ್ನು ನೋಡಿ"
  },
  missionSection: {
    badge: "ಸೈಟ್ ಕೇರ್ ಸೊಸೈಟಿ",
    title: "ಆಸ್ಪತ್ರೆಯಾಚೆಗಿನ ನಮ್ಮ ಸೇವೆ.",
    desc: "ನಮ್ಮ ಸೈಟ್ ಕೇರ್ ಸೊಸೈಟಿಯು ಬಡ ಜನರಿಗೆ ಉಚಿತ ಕಣ್ಣಿನ ತಪಾಸಣಾ ಶಿಬಿರಗಳು, ಜಾಗೃತಿ ಕಾರ್ಯಕ್ರಮಗಳು ಮತ್ತು ರಿಯಾಯಿತಿ ದರದ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆಗಳನ್ನು ನೀಡಲು ಸಮರ್ಪಿತವಾಗಿದೆ. ಸ್ಪಷ್ಟ ದೃಷ್ಟಿ ಪ್ರತಿಯೊಬ್ಬರ ಹಕ್ಕು ಎಂದು ನಾವು ನಂಬುತ್ತೇವೆ.",
    findOutMore: "ನಮ್ಮ ಬಗ್ಗೆ ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ"
  },
  gallerySection: {
    badge: "ಗ್ಯಾಲರಿ",
    title: "ನಮ್ಮ ಸೇವಾ ಪ್ರಪಂಚದ ಒಂದು ನೋಟ.",
    subtitle: "ನಮ್ಮ ಸೌಲಭ್ಯಗಳು, ತಂತ್ರಜ್ಞಾನಗಳು ಮತ್ತು ರೋಗಿಗಳ ಆರೈಕೆಯ ಕ್ಷಣಗಳು.",
    viewFull: "ಸಂಪೂರ್ಣ ಗ್ಯಾಲರಿ ವೀಕ್ಷಿಸಿ",
    pageTitle: "ನಮ್ಮ ಗ್ಯಾಲರಿ",
    pageSubtitle: "ನಮ್ಮ ಅತ್ಯಾಧುನಿಕ ಸೌಲಭ್ಯಗಳು, ಸಮರ್ಪಿತ ವೈದ್ಯಕೀಯ ತಂಡ, ಸಮುದಾಯ ಆರೋಗ್ಯ ಶಿಬಿರಗಳು ಮತ್ತು ಆಧುನಿಕ ಮೂಲಸೌಕರ್ಯಗಳನ್ನು ಅನ್ವೇಷಿಸಿ.",
    photos: "ಫೋಟೋಗಳು",
    all: "ಎಲ್ಲವೂ",
    campBadge: "ಆರೋಗ್ಯ ಶಿಬಿರ",
    clinicBadge: "ಕ್ಲಿನಿಕ್ ಮತ್ತು ಒಟಿ",
    close: "ಮುಚ್ಚಿ",
    prev: "ಹಿಂದಿನದು",
    next: "ಮುಂದಿನದು"
  },
  contactSection: {
    badge: "ಸಂಪರ್ಕಿಸಿ",
    title: "ನಿಮ್ಮ ಸಹಾಯಕ್ಕೆ ನಾವು ಸದಾ ಸಿದ್ಧ.",
    subtitle: "ಯಾವುದೇ ವಿಚಾರಣೆಗಳು, ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್‌ಗಳು ಅಥವಾ ತುರ್ತು ಕಣ್ಣಿನ ಆರೈಕೆಗಾಗಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ.",
    mainClinicBadge: "ಮುಖ್ಯ ಆಸ್ಪತ್ರೆಯ ಸ್ಥಳ",
    mainClinicTitle: "ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ",
    mainClinicLocation: "ಸಾಂಗ್ಲಿ, ಮಹಾರಾಷ್ಟ್ರ",
    openInMaps: "ಗೂಗಲ್ ಮ್ಯಾಪ್ಸ್‌ನಲ್ಲಿ ನೋಡಿ",
    getInTouch: "ಸಂಪರ್ಕಿಸಿ",
    exploreAllBranches: "ಎಲ್ಲಾ ಶಾಖೆಗಳನ್ನು ನೋಡಿ",
    pageTitle: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
    pageSubtitle: "ನಿಮಗೆ ಸಹಾಯ ಮಾಡಲು ನಾವು ಇಲ್ಲಿದ್ದೇವೆ. ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಅಥವಾ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್‌ಗಳಿಗಾಗಿ ಸಂಪರ್ಕಿಸಿ.",
    mainClinic: "ಮುಖ್ಯ ಆಸ್ಪತ್ರೆ",
    address: "ವಿಳಾಸ",
    phone: "ಫೋನ್",
    whatsapp: "ವಾಟ್ಸಾಪ್",
    email: "ಇಮೇಲ್",
    workingHours: "ಕೆಲಸದ ಸಮಯ",
    monSatHours: "ಸೋಮ - ಶನಿ: ಬೆಳಗ್ಗೆ ೯:೦೦ - ರಾತ್ರಿ ೮:೦೦",
    sundayHours: "ಭಾನುವಾರ: ರಜೆ",
    callNow: "ಈಗಲೇ ಕರೆ ಮಾಡಿ",
    messageUs: "ಸಂದೇಶ ಕಳುಹಿಸಿ",
    sendEmail: "ಇಮೇಲ್ ಕಳುಹಿಸಿ",
    name: "ಪೂರ್ಣ ಹೆಸರು *",
    phoneNumber: "ಫೋನ್ ಸಂಖ್ಯೆ *",
    emailAddress: "ಇಮೇಲ್ ವಿಳಾಸ",
    subject: "ವಿಷಯ",
    message: "ಸಂದೇಶ *",
    submitEnquiry: "ವಿಚಾರಣೆ ಸಲ್ಲಿಸಿ",
    namePlaceholder: "ಉದಾ. ಸುರೇಶ್ ಕುಮಾರ್",
    phonePlaceholder: "+೯೧ ೯೮೭೬೫ ೪೩೨೧೦",
    emailPlaceholder: "suresh@example.com",
    subjectPlaceholder: "ನಾವು ನಿಮಗೆ ಹೇಗೆ ಸಹಾಯ ಮಾಡಬಹುದು?",
    messagePlaceholder: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ವಿಚಾರಣೆಯನ್ನು ವಿವರಿಸಿ...",
    contactSuccess: "ನಿಮ್ಮ ಸಂದೇಶಕ್ಕೆ ಧನ್ಯವಾದಗಳು. ನಮ್ಮ ತಂಡವು ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ."
  },
  appointmentSection: {
    pageTitle: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಕಾಯ್ದಿರಿಸಿ",
    formTitle: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್‌ಗಾಗಿ ವಿನಂತಿ",
    formSubtitle: "ಕೆಳಗಿನ ಫಾರ್ಮ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡಿ ಮತ್ತು ನಾವು ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತೇವೆ.",
    fullName: "ಪೂರ್ಣ ಹೆಸರು *",
    phone: "ಫೋನ್ ಸಂಖ್ಯೆ *",
    email: "ಇಮೇಲ್ ವಿಳಾಸ",
    selectBranch: "ಶಾಖೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ *",
    chooseBranch: "ಶಾಖೆಯನ್ನು ಆರಿಸಿ...",
    selectDoctor: "ವೈದ್ಯರನ್ನು ಆಯ್ಕೆಮಾಡಿ (ಐಚ್ಛಿಕ)",
    chooseDoctor: "ವೈದ್ಯರನ್ನು ಆರಿಸಿ...",
    otherDoctor: "ಇತರ ವೈದ್ಯರು",
    enterDoctorName: "ವೈದ್ಯರ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    selectService: "ಸೇವೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ (ಐಚ್ಛಿಕ)",
    chooseService: "ಸೇವೆಯನ್ನು ಆರಿಸಿ...",
    preferredDate: "ಆದ್ಯತೆಯ ದಿನಾಂಕ *",
    preferredTime: "ಆದ್ಯತೆಯ ಸಮಯ *",
    chooseTime: "ಸಮಯವನ್ನು ಆರಿಸಿ...",
    morning: "ಬೆಳಗ್ಗೆ (೯:೦೦ AM - ೧:೦೦ PM)",
    afternoon: "ಮಧ್ಯಾಹ್ನ (೧:೦೦ PM - ೫:೦೦ PM)",
    evening: "ಸಂಜೆ (೫:೦೦ PM - ೮:೦೦ PM)",
    message: "ಹೆಚ್ಚುವರಿ ಟಿಪ್ಪಣಿಗಳು (ಐಚ್ಛಿಕ)",
    messagePlaceholder: "ಯಾವುದೇ ನಿರ್ದಿಷ್ಟ ಕಣ್ಣಿನ ಸಮಸ್ಯೆ ಅಥವಾ ವೈದ್ಯಕೀಯ ಹಿನ್ನೆಲೆ...",
    submitBtn: "ಈಗಲೇ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ",
    submitting: "ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...",
    successMsg: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು. ವಿವರಗಳನ್ನು ದೃಢೀಕರಿಸಲು ನಮ್ಮ ತಂಡ ಶೀಘ್ರದಲ್ಲೇ ಸಂಪರ್ಕಿಸುತ್ತದೆ."
  },
  aboutSection: {
    heroTitle1: "ಅಗ್ರಗಣ್ಯ",
    heroTitle2: "ನೇತ್ರ ಆರೈಕೆ",
    heroP1: "ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆಯನ್ನು ಒಂದು ಪ್ರಮುಖ ಉದ್ದೇಶದೊಂದಿಗೆ ಸ್ಥಾಪಿಸಲಾಯಿತು: ಸಮಾಜಕ್ಕೆ ವಿಶ್ವದರ್ಜೆಯ ಹಾಗೂ ಕೈಗೆಟುಕುವ ಕಣ್ಣಿನ ಆರೈಕೆಯನ್ನು ಒದಗಿಸುವುದು. ದಶಕಗಳಿಂದ ನಾವು ನೇತ್ರ ಚಿಕಿತ್ಸೆಯಲ್ಲಿ ಮುಂಚೂಣಿಯಲ್ಲಿದ್ದೇವೆ.",
    heroP2: "ಡಾ. ರಮಾಕಾಂತ್ ಟೆಕ್ಕೆ ಮತ್ತು ಡಾ. ವಿಶಾಖಾ ಟೆಕ್ಕೆ ಅವರ ಮಾರ್ಗದರ್ಶನದಲ್ಲಿ, ನಮ್ಮ ಆಸ್ಪತ್ರೆಯು ಅತ್ಯಾಧುನಿಕ ವೈದ್ಯಕೀಯ ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ಕಾಳಜಿಯುಕ್ತ ಆರೈಕೆಯನ್ನು ಒದಗಿಸುತ್ತದೆ.",
    meetDoctors: "ನಮ್ಮ ವೈದ್ಯರನ್ನು ಭೇಟಿಯಾಗಿ",
    guidingPrinciples: "ನಮ್ಮ ಮಾರ್ಗದರ್ಶಿ ತತ್ವಗಳು",
    missionVisionTitle: "ನಮ್ಮ ಗುರಿ ಮತ್ತು ದೃಷ್ಟಿಕೋನ",
    missionVisionSub: "ಸ್ಪಷ್ಟ ದೃಷ್ಟಿ, ನೈತಿಕ ವೈದ್ಯಕೀಯ ಪದ್ಧತಿ ಮತ್ತು ಅತ್ಯಾಧುನಿಕ ನೇತ್ರ ಆರೈಕೆಯ ಮೂಲಕ ಸಮಾಜದ ಸಬಲೀಕರಣ.",
    missionTitle: "ನಮ್ಮ ಧ್ಯೇಯ (Mission)",
    ourPurpose: "ನಮ್ಮ ಉದ್ದೇಶ",
    missionText: "ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ, ಸಾಂಗ್ಲಿಯಲ್ಲಿ ನಮ್ಮ ಧ್ಯೇಯವೆಂದರೆ ಎಲ್ಲಾ ವಯಸ್ಸಿನ ರೋಗಿಗಳಿಗೆ ಸಮಗ್ರ, ಸುಧಾರಿತ ಮತ್ತು ಕೈಗೆಟುಕುವ ಕಣ್ಣಿನ ಆರೈಕೆಯನ್ನು ಒದಗಿಸುವುದು. ನಿಖರವಾದ ರೋಗನಿರ್ಣಯ, ನೈತಿಕ ವೈದ್ಯಕೀಯ ಪದ್ಧತಿಗಳು ಮತ್ತು ಕಾಳಜಿಯುಕ್ತ ಆರೈಕೆಗೆ ನಾವು ಬದ್ಧರಾಗಿದ್ದೇವೆ.",
    visionTitle: "ನಮ್ಮ ದೃಷ್ಟಿಕೋನ (Vision)",
    ourAspiration: "ನಮ್ಮ ಆಕಾಂಕ್ಷೆ",
    visionText: "ನೇತ್ರವಿಜ್ಞಾನದಲ್ಲಿ ಉನ್ನತ ಗುಣಮಟ್ಟದ ವೈದ್ಯಕೀಯ ಮತ್ತು ಶಸ್ತ್ರಚಿಕಿತ್ಸಾ ಸೇವೆಗಳನ್ನು ನೀಡುವ ವಿಶ್ವಾಸಾರ್ಹ ಶ್ರೇಷ್ಠತೆಯ ಕೇಂದ್ರವಾಗಿ ಗುರುತಿಸಿಕೊಳ್ಳುವುದು. ತಡೆಗಟ್ಟಬಹುದಾದ ಅಂಧತ್ವವನ್ನು ಹೋಗಲಾಡಿಸುವುದು ನಮ್ಮ ಪ್ರಮುಖ ಗುರಿಯಾಗಿದೆ.",
    tagAccurate: "ನಿಖರ ರೋಗನಿರ್ಣಯ",
    tagEthical: "ನೈತಿಕ ಚಿಕಿತ್ಸೆ",
    tagAffordable: "ಕೈಗೆಟುಕುವ ದರ",
    tagAdvanced: "ಸುಧಾರಿತ ತಂತ್ರಜ್ಞಾನ",
    tagExcellence: "ವೈದ್ಯಕೀಯ ಶ್ರೇಷ್ಠತೆ",
    tagCommunity: "ಸಮುದಾಯ ಸೇವೆ"
  },
  footer: {
    brandDesc: "ಸ್ಪಷ್ಟ ದೃಷ್ಟಿ. ಉತ್ತಮ ಆರೈಕೆ. ಹೊಲಿಗೆ ರಹಿತ ಕಣ್ಣಿನ ಪೊರೆ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ, ಲೇಸರ್ ದೃಷ್ಟಿ ತಿದ್ದುಪಡಿ ಮತ್ತು ೬ ಕೇಂದ್ರಗಳಲ್ಲಿ ಸಮಗ್ರ ಕಣ್ಣಿನ ಆರೈಕೆಗೆ ಸಮರ್ಪಿತ.",
    nabhCare: "NABH ಗುಣಮಟ್ಟದ ಆರೈಕೆ",
    modernCenters: "೬ ಆಧುನಿಕ ಕೇಂದ್ರಗಳು",
    connectWithUs: "ನಮ್ಮೊಂದಿಗೆ ಸಂಪರ್ಕದಲ್ಲಿರಿ",
    quickLinks: "ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು",
    ourBranches: "ನಮ್ಮ ಶಾಖೆಗಳು",
    popularServices: "ಪ್ರಮುಖ ಚಿಕಿತ್ಸೆಗಳು",
    needHelp: "ತುರ್ತು ಆರೈಕೆ ಬೇಕೇ?",
    callEmergency: "ತುರ್ತು ಸಹಾಯವಾಣಿ",
    whatsappConsult: "ವಾಟ್ಸಾಪ್ ಸಮಾಲೋಚನೆ",
    dailyOpd: "ದೈನಂದಿನ ಒಪಿಡಿ ಸಮಯ",
    dailyOpdHours: "ಸೋಮ - ಶನಿ: ಬೆಳಗ್ಗೆ ೯:೦೦ - ರಾತ್ರಿ ೮:೦೦",
    allRightsReserved: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    privacyPolicy: "ಗೌಪ್ಯತೆ ನೀತಿ",
    termsOfService: "ಸೇವಾ ನಿಯಮಗಳು",
    chooseLanguage: "ಭಾಷೆ"
  },
  servicesList: {
    "lasik-laser": {
      name: "ಲ್ಯಾಸಿಕ್ ಲೇಸರ್ ದೃಷ್ಟಿ ತಿದ್ದುಪಡಿ (Lasik)",
      category: "ವಕ್ರೀಭವನ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ",
      description: "ಕನ್ನಡಕವನ್ನು ಶಾಶ್ವತವಾಗಿ ತೆಗೆದುಹಾಕಲು ಮತ್ತು ಕನ್ನಡಕವಿಲ್ಲದೆ ಸ್ಪಷ್ಟ ದೃಷ್ಟಿ ಪಡೆಯಲು ಬ್ಲೇಡ್-ಮುಕ್ತ ಸುಧಾರಿತ ಲೇಸರ್ ಚಿಕಿತ್ಸೆ."
    },
    "multifocal-lens": {
      name: "ಮಲ್ಟಿಫೋಕಲ್ ಲೆನ್ಸ್ ಇಂಪ್ಲಾಂಟ್ಸ್",
      category: "ಲೆನ್ಸ್ ಅಳವಡಿಕೆ",
      description: "ಓದುವ ಕನ್ನಡಕವಿಲ್ಲದೆ ಹತ್ತಿರದ, ಮಧ್ಯಮ ಮತ್ತು ದೂರದ ಸ್ಪಷ್ಟ ದೃಷ್ಟಿಗಾಗಿ ಪ್ರೀಮಿಯಂ ಇಂಟ್ರಾಕ್ಯುಲರ್ ಲೆನ್ಸ್ (IOL) ಇಂಪ್ಲಾಂಟ್‌ಗಳು."
    },
    "phaco-surgery": {
      name: "ಫ್ಯಾಕೋಎಮಲ್ಸಿಫಿಕೇಶನ್ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ (Phaco)",
      category: "ಕಣ್ಣಿನ ಪೊರೆ ಆರೈಕೆ",
      description: "ಅಲ್ಟ್ರಾಸೌಂಡ್ ತಂತ್ರಜ್ಞಾನದೊಂದಿಗೆ ಸೂಕ್ಷ್ಮ ಛೇದನದ ಮೂಲಕ ಸುರಕ್ಷಿತ, ನಿಖರ ಮತ್ತು ತ್ವರಿತ ದೃಷ್ಟಿ ಮರುಪಡೆಯುವ ಆಧುನಿಕ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ."
    },
    "stitchless-cataract-surgery": {
      name: "ಹೊಲಿಗೆ ರಹಿತ ಕಣ್ಣಿನ ಪೊರೆ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ (MICS)",
      category: "ಕಣ್ಣಿನ ಪೊರೆ ಆರೈಕೆ",
      description: "ನೋವು ರಹಿತ, ಇಂಜೆಕ್ಷನ್ ರಹಿತ ಮತ್ತು ಹೊಲಿಗೆ ರಹಿತ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ ಹಾಗೂ ಮಡಚಬಹುದಾದ ಲೆನ್ಸ್ ಅಳವಡಿಕೆಯೊಂದಿಗೆ ಅದೇ ದಿನ ಮನೆಗೆ ತೆರಳುವ ಸೌಲಭ್ಯ."
    },
    "glaucoma-treatment": {
      name: "ಗ್ಲುಕೋಮಾ (ಕಾಚುಬಿಂದು) ಚಿಕಿತ್ಸೆ ಮತ್ತು ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ",
      category: "ಗ್ಲುಕೋಮಾ",
      description: "ಕಣ್ಣಿನ ಒತ್ತಡದ ಆರಂಭಿಕ ಪತ್ತೆ, ದೃಷ್ಟಿ ಕ್ಷೇತ್ರ ಪರೀಕ್ಷೆ, ಔಷಧೀಯ ನಿರ್ವಹಣೆ ಮತ್ತು ಸುಧಾರಿತ ಗ್ಲುಕೋಮಾ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ."
    },
    "squint-treatment": {
      name: "ಮೆಳ್ಳೆಗಣ್ಣು (ಸ್ಕ್ವಿಂಟ್) ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ ಮತ್ತು ತಿದ್ದುಪಡಿ",
      category: "ಮಕ್ಕಳ ನೇತ್ರ ಮತ್ತು ಮೆಳ್ಳೆಗಣ್ಣು",
      description: "ಮಕ್ಕಳು ಮತ್ತು ವಯಸ್ಕರಲ್ಲಿ ಮೆಳ್ಳೆಗಣ್ಣಿನ ಸಮಗ್ರ ಪರೀಕ್ಷೆ, ವ್ಯಾಯಾಮಗಳು ಮತ್ತು ನಿಖರ ಸ್ನಾಯು ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ."
    },
    "oct-retina-screening": {
      name: "ಒಸಿಟಿ ೩ಡಿ ರೆಟಿನಾ ತಪಾಸಣೆ ಮತ್ತು ಇಮೇಜಿಂಗ್",
      category: "ರೋಗನಿರ್ಣಯ ಇಮೇಜಿಂಗ್",
      description: "ಆಪ್ಟಿಕಲ್ ಕೊಹೆರೆನ್ಸ್ ಟೊಮೊಗ್ರಫಿ (OCT) ಮೂಲಕ ರೆಟಿನಾ ಮತ್ತು ನೇತ್ರ ನರಗಳ 3D ಸೂಕ್ಷ್ಮ ಚಿತ್ರಣ ಮತ್ತು ಪರೀಕ್ಷೆ."
    },
    "retina-disorders-surgery": {
      name: "ರೆಟಿನಾ ಕಾಯಿಲೆಗಳ ರೋಗನಿರ್ಣಯ ಮತ್ತು ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ",
      category: "ವಿಟ್ರಿಯೊರೆಟಿನಲ್ ಆರೈಕೆ",
      description: "ರೆಟಿನಾ ಡಿಟ್ಯಾಚ್‌ಮೆಂಟ್ ದುರಸ್ತಿ, ಮ್ಯಾಕ್ಯುಲರ್ ಹೋಲ್ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ ಮತ್ತು ಲೇಸರ್ ಫೋಟೊಕೊಆಗ್ಯುಲೇಶನ್ ಚಿಕಿತ್ಸೆ."
    },
    "oculoplastic-surgery": {
      name: "ಅಕ್ಯುಲೋಪ್ಲಾಸ್ಟಿಕ್ ಮತ್ತು ಕಣ್ಣುರೆಪ್ಪೆಯ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ",
      category: "ಪುನರ್ನಿರ್ಮಾಣ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ",
      description: "ಕಣ್ಣುರೆಪ್ಪೆಗಳ ದುರಸ್ತಿ (Ptosis), ಕಣ್ಣೀರಿನ ನಾಳಗಳ ಚಿಕಿತ್ಸೆ ಮತ್ತು ಕಣ್ಣಿನ ಸೌಂದರ್ಯವರ್ಧಕ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ."
    },
    "pediatric-eye-surgery": {
      name: "ಮಕ್ಕಳ ಕಣ್ಣಿನ ಆರೈಕೆ ಮತ್ತು ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ",
      category: "ಮಕ್ಕಳ ನೇತ್ರ ಆರೈಕೆ",
      description: "ಹುಟ್ಟಿನಿಂದ ಬಂದ ಕಣ್ಣಿನ ಪೊರೆ, ಸೋಮಾರಿ ಕಣ್ಣು (Amblyopia) ಮತ್ತು ದೃಷ್ಟಿದೋಷಗಳಿಗೆ ಪ್ರೀತಿಯಿಂದ ಕೂಡಿದ ವಿಶೇಷ ಚಿಕಿತ್ಸೆ."
    },
    "contact-lens-facility": {
      name: "ವಿಶೇಷ ಕಾಂಟ್ಯಾಕ್ಟ್ ಲೆನ್ಸ್ ಕ್ಲಿನಿಕ್",
      category: "ಆಪ್ಟಿಕಲ್ ಆರೈಕೆ",
      description: "ಸಾಫ್ಟ್, ಟೋರಿಕ್, ಮಲ್ಟಿಫೋಕಲ್ ಮತ್ತು ಆರ್‌ಜಿಪಿ ಕಾಂಟ್ಯಾಕ್ಟ್ ಲೆನ್ಸ್‌ಗಳ ನಿಖರ ತಪಾಸಣೆ ಮತ್ತು ಜೋಡಣೆ ಸೌಲಭ್ಯ."
    },
    "lasru-dcr-surgery": {
      name: "ಕಣ್ಣೀರಿನ ನಾಳ (DCR / Lasru) ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ",
      category: "ಕಣ್ಣೀರಿನ ನಾಳ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ",
      description: "ಕಣ್ಣಿನಲ್ಲಿ ಸದಾ ನೀರು ಬರುವುದು ಮತ್ತು ಮುಚ್ಚಿಹೋದ ಕಣ್ಣೀರಿನ ನಾಳಗಳ ನಿವಾರಣೆಗೆ ಸುಧಾರಿತ ಡಿಸಿಆರ್ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ."
    },
    "computerized-vision-testing": {
      name: "ಕಂಪ್ಯೂಟರೀಕೃತ ದೃಷ್ಟಿ ಮತ್ತು ನಂಬರ್ ತಪಾಸಣೆ",
      category: "ರೋಗನಿರ್ಣಯ ಪರೀಕ್ಷೆ",
      description: "ಆಧುನಿಕ ಕಂಪ್ಯೂಟರೀಕೃತ ಉಪಕರಣಗಳ ಮೂಲಕ ಕನ್ನಡಕದ ನಂಬರ್‌ನ ನಿಖರ ಮತ್ತು ವೇಗದ ಪರೀಕ್ಷೆ."
    },
    "diabetic-retinopathy": {
      name: "ಮಧುಮೇಹ ರೆಟಿನೋಪತಿ ತಪಾಸಣೆ ಮತ್ತು ಚಿಕಿತ್ಸೆ",
      category: "ವಿಟ್ರಿಯೊರೆಟಿನಲ್ ಆರೈಕೆ",
      description: "ಸಕ್ಕರೆ ಕಾಯಿಲೆಯಿಂದ ಕಣ್ಣಿನ ಪರದೆಗೆ ಆಗುವ ಹಾನಿಯ ತಪಾಸಣೆ, ಗ್ರೀನ್ ಲೇಸರ್ ಥೆರಪಿ ಮತ್ತು ಸುಧಾರಿತ ಇಂಜೆಕ್ಷನ್‌ಗಳು."
    },
    "general-eye-care": {
      name: "ಸಮಗ್ರ ಸಾಮಾನ್ಯ ಕಣ್ಣಿನ ಆರೈಕೆ ಮತ್ತು ಚಿಕಿತ್ಸೆ",
      category: "ಸಾಮಾನ್ಯ ನೇತ್ರಶಾಸ್ತ್ರ",
      description: "ಕಣ್ಣಿನ ಸೋಂಕು, ಅಲರ್ಜಿ, ಒಣ ಕಣ್ಣು (Dry Eye), ಕಣ್ಣಿನಲ್ಲಿ ಕಸ ಬೀಳುವುದು ಮತ್ತು ತುರ್ತು ಗಾಯಗಳಿಗೆ ತಕ್ಷಣದ ಚಿಕಿತ್ಸೆ."
    },
    "cornea-disorders-surgery": {
      name: "ಕಾರ್ನಿಯಾ ಕಾಯಿಲೆಗಳು ಮತ್ತು ಕಸಿ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ",
      category: "ಕಾರ್ನಿಯಾ ಆರೈಕೆ",
      description: "ಕಾರ್ನಿಯಾ ಹುಣ್ಣುಗಳು, ಕೆರಟೊಕೊನಸ್ (C3R), ಕಣ್ಣಿನ ಪೊರೆ ಮಾಂಸ ಬೆಳವಣಿಗೆ ಮತ್ತು ಕಾರ್ನಿಯಾ ಕಸಿ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ."
    }
  },
  branchList: {
    astha: {
      name: "ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ, ಆಷ್ಟಾ",
      city: "ಆಷ್ಟಾ",
      area: "ಆಷ್ಟಾ",
      address: "ರುಕಡೆ ಪೆಟ್ರೋಲ್ ಬಂಕ್ ಹತ್ತಿರ, ಸ್ವಾಗತ್ ಹೋಟೆಲ್, ಮೊದಲ ಮಹಡಿ, ಮೇನ್ ರೋಡ್, ಆಷ್ಟಾ",
      facilities: ["ಸುಧಾರಿತ ನೇತ್ರ ಒಪಿಡಿ", "ಆಪ್ಟಿಕಲ್ ಮಳಿಗೆ", "ಕಣ್ಣಿನ ಪೊರೆ ಮೌಲ್ಯಮಾಪನ", "ಕಂಪ್ಯೂಟರೀಕೃತ ದೃಷ್ಟಿ ತಪಾಸಣೆ"]
    },
    jath: {
      name: "ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ, ಜತ್",
      city: "ಜತ್",
      area: "ಜತ್",
      address: "ರುಕಡೆ ಪೆಟ್ರೋಲ್ ಜಲ ವಾಡಿ ಕಾಂಪ್ಲೆಕ್ಸ್ ಹತ್ತಿರ, ಜತ್",
      facilities: ["ಸಮಾಲೋಚನಾ ಕೊಠಡಿಗಳು", "ಆಪ್ಟಿಕಲ್ ಕೇಂದ್ರ", "ದೃಷ್ಟಿ ಪರೀಕ್ಷೆ", "ಫಾರ್ಮಸಿ"]
    },
    atpadi: {
      name: "ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ, ಆಟ್ಪಾಡಿ",
      city: "ಆಟ್ಪಾಡಿ",
      area: "ಆಟ್ಪಾಡಿ",
      address: "ಕೆ.ಎಸ್.ಆರ್.ಟಿ.ಸಿ ಬಸ್ ನಿಲ್ದಾಣದ ಹತ್ತಿರ, ರೋವಟ್ ಆಸ್ಪತ್ರೆಯ ಮೇಲ್ಭಾಗ, ಆಟ್ಪಾಡಿ",
      facilities: ["ಸಮಗ್ರ ಕಣ್ಣಿನ ಆರೈಕೆ", "ಆಪ್ಟಿಕಲ್ ಮಳಿಗೆ", "ರೋಗನಿರ್ಣಯ ಸೌಲಭ್ಯಗಳು"]
    },
    solapur: {
      name: "ರಾಘವೇಂದ್ರ ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ, ಸೋಲಾಪುರ",
      city: "ಸೋಲಾಪುರ",
      area: "ಸೋಲಾಪುರ",
      address: "ಮಾಜಿ ಸೈನಿಕ ನಗರ, ವಿಜಾಪುರ ರಸ್ತೆ, ಸೋಲಾಪುರ",
      facilities: ["ಸುಧಾರಿತ ಶಸ್ತ್ರಚಿಕಿತ್ಸಾ ಘಟಕ", "ಲೇಸರ್ ಚಿಕಿತ್ಸೆ", "ಆಪ್ಟಿಕಲ್ ಮಳಿಗೆ", "ಡಯಾಗ್ನೋಸ್ಟಿಕ್ ಸೆಂಟರ್"]
    },
    athani: {
      name: "ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ, ಅಥಣಿ",
      city: "ಅಥಣಿ",
      area: "ಅಥಣಿ",
      address: "ಶಾಂತಿನಗರ ಹಲ್ಯಾಳ ಕ್ರೂಶಿಯಲ್ ರಸ್ತೆ, ಅಥಣಿ",
      facilities: ["ಸಮಾಲೋಚನಾ ಕೊಠಡಿಗಳು", "ಆಪ್ಟಿಕಲ್ ಮಳಿಗೆ", "ಮಕ್ಕಳ ಕಣ್ಣಿನ ತಪಾಸಣೆ"]
    },
    sangola: {
      name: "ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ, ಸಾಂಗೋಲಾ",
      city: "ಸಾಂಗೋಲಾ",
      area: "ಸಾಂಗೋಲಾ",
      address: "ಮೌಲಿ ಹೈಟ್ಸ್, ಮಿರಾಜ್ ರಸ್ತೆ, ಗೌರಿ ಪೆಟ್ರೋಲ್ ಬಂಕ್ ಹತ್ತಿರ, ಸಾಂಗೋಲಾ",
      facilities: ["ಸಂಪೂರ್ಣ ಕಣ್ಣಿನ ತಪಾಸಣೆ", "ಆಪ್ಟಿಕಲ್ ವಿತರಣೆ", "ಫಾರ್ಮಸಿ", "ಮೈನರ್ ಒಟಿ"]
    }
  },
  doctorsList: {
    "dr-ramakant-tekke": {
      name: "ಡಾ. ರಮಾಕಾಂತ್ ಟೆಕ್ಕೆ",
      qualification: "ನೇತ್ರಶಾಸ್ತ್ರಜ್ಞ (Ophthalmology)",
      specialization: "ಕಣ್ಣಿನ ತಜ್ಞರು ಮತ್ತು ಶಸ್ತ್ರಚಿಕಿತ್ಸಕರು",
      profile: "ಸಮಗ್ರ ಕಣ್ಣಿನ ಆರೈಕೆ ಮತ್ತು ಸುಧಾರಿತ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆಗಳಲ್ಲಿ ದೀರ್ಘಕಾಲದ ಅನುಭವ ಹೊಂದಿರುವ ಪ್ರಖ್ಯಾತ ನೇತ್ರ ತಜ್ಞರು."
    },
    "dr-vishakha-tekke": {
      name: "ಡಾ. ವಿಶಾಖಾ ಟೆಕ್ಕೆ",
      qualification: "M.S. (Opth) & M.B.B.S., D.O.M.S.",
      specialization: "ನೇತ್ರಶಾಸ್ತ್ರಜ್ಞರು ಮತ್ತು ಕಣ್ಣಿನ ಸರ್ಜನ್",
      profile: "ಆಧುನಿಕ ದೃಷ್ಟಿ ತಿದ್ದುಪಡಿ ಪ್ರಕ್ರಿಯೆಗಳು, ಕಣ್ಣಿನ ಪೊರೆ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ ಮತ್ತು ರೋಗಿಗಳ ಕಾಳಜಿಯಲ್ಲಿ ಪರಿಣಿತರು."
    }
  }
};
